import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_NAME_CONTEXT } from '@/constant/Context';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';
import store from '@/store';
import Permission from './index';

export function permissionPlanner(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  // const isHighSchool = PermissionClass.can(LIST_PERMISSION.BOOKS_DEGREE_HIGH_SCHOOL);
  const isPlanner = PermissionClass.can(LIST_PERMISSION.PLANNER);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  const hasAccess = isPlanner || isPlanFree;

  if (hasAccess) {
    next();
    return;
  }

  next({ name: 'Dashboard' });
}

export function permissionPlannerContext(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const context = to.params?.context;
  const PermissionClass = new Permission();

  if (context !== LIST_NAME_CONTEXT.PLANNER) {
    next();
    return;
  }

  if (!PermissionClass.can(LIST_PERMISSION.PLANNER)) {
    next({
      name: 'Planner'
    });
  }

  next();
}
